import type { PsfShareChannel, ShareChannel } from 'src/app/pages/psf/share/shared/types';

export const SHARE_CHANNELS: Record<string, true> = {
	copy: true,
	email: true,
	facebook: true,
	facebookMessenger: true,
	instagram: true,
	line: true,
	sms: true,
	twitter: true,
	vk: true,
	whatsapp: true,
	nextdoor: true,
	mobileNativeShare: true,
} satisfies Record<ShareChannel, true>;

export const PSF_SHARE_CHANNELS: Record<PsfShareChannel, true> = {
	copy: true,
	email: true,
	facebook: true,
	facebookMessenger: true,
	instagram: true,
	line: true,
	sms: true,
	twitter: true,
	vk: true,
	whatsapp: true,
	nextdoor: true,
	mobileNativeShare: true,
};
